import { NavigationItem } from './interfaces/navigationList.interface';

export const getLeafItemByRoutePath = (
  routes: NavigationItem[],
  routePath: number[],
): NavigationItem | null => {
  let currentLevel = routes;
  let currentItem: NavigationItem | null = null;

  for (const id of routePath) {
    currentItem = currentLevel.find(item => item.id === id) || null;
    if (!currentItem) {
      return null; // Path is invalid
    }
    currentLevel = currentItem.children || [];
  }

  return currentItem;
};
